import { userLocal } from '@/utils/ipeUserLocalState';

const WORKFLOW_TASKS_STORAGE_KEY = 'ipe-workflow-tasks-v2';

function loadTasksFromStorage() {
  try {
    const parsed = userLocal.getJson(WORKFLOW_TASKS_STORAGE_KEY, []);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** 本地 ID 被服务端替换后，仍可通过 legacyLocalId 找到任务 */
export function resolveWorkflowTaskId(taskId) {
  if (!taskId) return taskId;
  const list = loadTasksFromStorage();
  if (list.some((t) => t.id === taskId)) return taskId;
  const migrated = list.find((t) => t.legacyLocalId === taskId);
  return migrated?.id || taskId;
}

export function resolveWorkflowTaskIdFromList(taskId, list) {
  if (!taskId) return taskId;
  if (list.some((t) => t.id === taskId)) return taskId;
  const migrated = list.find((t) => t.legacyLocalId === taskId);
  return migrated?.id || taskId;
}
